var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36914 6.52459L12.0431 5.18792C12.2251 5.09697 12.4412 5.1067 12.6143 5.21364C12.7874 5.32058 12.8928 5.50949 12.8929 5.71295V9.68539C12.8928 9.88885 12.7874 10.0778 12.6143 10.1847C12.4412 10.2916 12.2251 10.3014 12.0431 10.2104L9.36914 8.87376V6.52459Z",
    stroke: "#828689",
    strokeWidth: 1.10117,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.32129,
    y: 4.17529,
    width: 7.04749,
    height: 7.04749,
    rx: 1.76187,
    stroke: "#828689",
    strokeWidth: 1.10117,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.704cb61ab7f1e5bb43d5a48d00a80216.svg";
export { ForwardRef as ReactComponent };